﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { ServiciosHelpText, ServiciosIcon } from "../../Servicios/Servicios";
import { ClientesServiciosDef } from "./ClientesServiciosDef";

export class ClientesServicios extends Entity<ClientesServiciosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ClientesServiciosDef(), parentKeys);
        super.Form = import('./ClientesServiciosForm').then((module) => module.ClientesServiciosForm);
        this.Icon = ServiciosIcon;
        this.HelpText = ServiciosHelpText;
        this.Title = "Servicio";
    }
}